import React, { useRef } from "react";
import "../Style/Hero.css";

// Import your video asset
import heroVideo from "../assets/add_more_image_into_this_video.mp4";

export default function HeroChart() {
  const videoRef = useRef(null);

  // Behavior setting:
  // Set to 'true' to pause on the end frame for 3s, then RESTART.
  // Set to 'false' to pause on the end frame and STOP completely.
  const SHOULD_LOOP = true; 
  const PAUSE_DURATION_MS = 3000; // 3 seconds freeze time

  const handleVideoEnded = () => {
    if (SHOULD_LOOP) {
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.play();
        }
      }, PAUSE_DURATION_MS);
    }
  };

  return (
    <section className="hero" aria-label="Hero section">
      {/* Background Video Viewport */}
      <div className="hero-slides-viewport">
        <div className="hero-slide active">
          <video
            ref={videoRef}
            src={heroVideo}
            className="hero-full-bg-img"
            autoPlay
            muted
            playsInline
            /* Note: 'loop' attribute removed so onEnded fires */
            onEnded={handleVideoEnded}
          />
        </div>
      </div>

      {/* Hero Foreground Content */}
      <div className="hero-overlay">
        {/* Location Tag */}
        <div className="hero-location animate-item dynamic-delay-1">
          <svg width="14" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
          <span>1.1755° N · 73.5093° E — MALÉ, MALDIVES</span>
        </div>

        {/* Hero Title */}
        <h1 className="hero-title animate-item dynamic-delay-2">
          Your Gateway to <br className="desktop-only" />
          Maldives ISO Compliance.
        </h1>

        {/* Subtitle */}
        <p className="hero-subtitle animate-item dynamic-delay-3">
          We guide Maldivian businesses through ISO 9001, 14001, and 45001 <br className="desktop-only" />
          — from first assessment to certified, audit-ready operations.
        </p>

        {/* Call to Action Buttons */}
        <div className="hero-buttons animate-item dynamic-delay-4">
          <a href="/contact" className="hero-btn primary-btn">
            Start your audit
          </a>
          <a href="/certifications" className="hero-btn secondary-btn">
            View our services
          </a>
        </div>

        {/* Key Metrics / Glassmorphism Cards */}
        <div className="hero-stats animate-item dynamic-delay-5">
          <div className="hero-stat-card">
            <svg className="stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <path d="M9 15l2 2 4-4"></path>
            </svg>
            <div className="stat-info">
              <strong>120+</strong>
              <span>Certifications guided</span>
            </div>
          </div>

          <div className="hero-stat-card">
            <svg className="stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="6" cy="6" r="3"></circle>
              <circle cx="18" cy="18" r="3"></circle>
              <path d="M20 4L4 20"></path>
            </svg>
            <div className="stat-info">
              <strong>15</strong>
              <span>Atolls served</span>
            </div>
          </div>

          <div className="hero-stat-card">
            <svg className="stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <path d="M9 12l2 2 4-4"></path>
            </svg>
            <div className="stat-info">
              <strong>98%</strong>
              <span>First-audit pass</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

